export default class ObservableProvDiv {
  public div!: string
  public outcome!: number[]

  public outcomeDisplay() {
    return `(${this.outcome.join(', ')})`
  }
}
